import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import userServices from './userServices';
import axios from 'axios';
let user;
try {
 user = JSON.parse(localStorage.getItem('user'));
} catch (error) {
  localStorage.removeItem('user');
}
const initialState = {
  user: user ? user : null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = '';
    },
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem('user',  JSON.stringify(action.payload));
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userRegister.pending, (state, action) => {
        state.isLoading = true;
        state.message = '';
      })
      .addCase(userRegister.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = '';
        // state.user = action.payload;
      })
      .addCase(userRegister.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(userLogin.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = '';
        state.user = action.payload;
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.payload;
        state.user = '';
      })
      .addCase(userLogout.fulfilled, (state) => {
        state.user = null;
      });
  },
});

export const userRegister = createAsyncThunk(
  'user/register',
  async (userDetails, thunkAPI) => {
    try {
      return await userServices.userRegister(userDetails);
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || 'Registration failed';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const userLogin = createAsyncThunk(
  'user/login',
  async (userDetails, thunkAPI) => {
    try {
      return await userServices.userLogin(userDetails);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const userLogout = createAsyncThunk(
  'user/logout',
  async (token, { rejectWithValue }) => {
    try {
      const response = await userServices.userLogout(token);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchCourse = async () => {
  const response = await axios.get('/api/course');
  return response.data;
};

export default userSlice.reducer;
export const { reset, setUser } = userSlice.actions;
